import { useDispatch, useSelector } from 'react-redux'
import { format } from 'url'
import * as R from 'ramda'

import { useRouter } from 'next/router'

import * as userSelectors from 'src/store/selectors/user'
import * as networkSelectors from 'src/store/selectors/network'

import { findSharedThreads } from 'src/components/conversations/data'

import { UserMenuType } from './types'

import transact from 'src/lib/data/transact'

export const useStartThread = () => {
  const userId = useSelector(userSelectors.currentUserIdSelector)
  const userUuid = useSelector(userSelectors.currentUserUuidSelector)
  const networkId = useSelector(networkSelectors.idSelector)
  const dispatch: $TSFixMe = useDispatch()
  const router = useRouter()

  const startThread = async (friend: UserMenuType) => {
    const friendId = parseInt(friend.legacyEid)
    const threadMembers = [userId, friendId]

    const mutualThreads = await dispatch(
      findSharedThreads(userId, threadMembers)
    )

    const hasThreads = !R.isEmpty(mutualThreads)

    const navigateToThread = (threadId: string) => {
      const pathname = `/n/${router.query.network}/user/${userUuid}/messages`
      const query = { thread: threadId }
      const url = format({ pathname, query })
      router.push(url)
    }

    if (hasThreads) {
      const [firstThread] = mutualThreads
      const { ':db/id': threadId } = firstThread
      navigateToThread(threadId)
    }

    if (!hasThreads) {
      const res = await transact([
        ['@thread/create-with-friend', { friendId, networkId }]
      ])

      const threadId = res['temp-thread']
      navigateToThread(threadId)
    }
  }

  return startThread
}
